/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RichAiModel } from './RichAiModel';
import { RichAiModelFromJSON, RichAiModelFromJSONTyped, RichAiModelToJSON } from './RichAiModel';

/**
 *
 * @export
 * @interface PaginatedRichAiModelList
 */
export interface PaginatedRichAiModelList {
  /**
   *
   * @type {number}
   * @memberof PaginatedRichAiModelList
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof PaginatedRichAiModelList
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof PaginatedRichAiModelList
   */
  previous?: string | null;
  /**
   *
   * @type {Array<RichAiModel>}
   * @memberof PaginatedRichAiModelList
   */
  results: Array<RichAiModel>;
}

/**
 * Check if a given object implements the PaginatedRichAiModelList interface.
 */
export function instanceOfPaginatedRichAiModelList(value: object): value is PaginatedRichAiModelList {
  if (!('count' in value) || value['count'] === undefined) return false;
  if (!('results' in value) || value['results'] === undefined) return false;
  return true;
}

export function PaginatedRichAiModelListFromJSON(json: any): PaginatedRichAiModelList {
  return PaginatedRichAiModelListFromJSONTyped(json, false);
}

export function PaginatedRichAiModelListFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PaginatedRichAiModelList {
  if (json == null) {
    return json;
  }
  return {
    count: json['count'],
    next: json['next'] == null ? undefined : json['next'],
    previous: json['previous'] == null ? undefined : json['previous'],
    results: (json['results'] as Array<any>).map(RichAiModelFromJSON),
  };
}

export function PaginatedRichAiModelListToJSON(value?: PaginatedRichAiModelList | null): any {
  if (value == null) {
    return value;
  }
  return {
    count: value['count'],
    next: value['next'],
    previous: value['previous'],
    results: (value['results'] as Array<any>).map(RichAiModelToJSON),
  };
}
